import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowIHelp } from './components/HowIHelp';
import { HowIWork } from './components/HowIWork';
import { Experience } from './components/Experience';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Craig Thomas | Strategy, Operations & Leadership';
    const description = 'Portland-based executive consultant helping organizations turn strategy into action, strengthen operations, and develop leaders through focused, part-time engagements.';
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);
  return <div className="w-full min-h-screen bg-paper text-ink font-sans" data-id="element-0" data-mp="3ijxokogyjwiu">
      <Navbar data-id="element-1" data-mp="3ijpet5g4t7bv" />
      <main data-id="element-2" data-mp="3ii4r9zs8ioni">
        <Hero data-id="element-3" data-mp="3mlawd43m29se" />
        <HowIHelp data-id="element-4" data-mp="3ml1234bj9ggw" />
        <HowIWork data-id="element-5" data-mp="3mkhou0wtvg97" />
        <Experience data-id="element-6" data-mp="3mjzpgvevclx2" />
        <About data-id="element-7" data-mp="3mj6hjr46bqdc" />
        <Contact data-id="element-8" data-mp="3rcj6618urx63" />
      </main>
      <Footer data-id="element-9" data-mp="3rdapodp6e4g0" />
    </div>;
}